import React from 'react';
import { PropTypes } from 'prop-types';
import colors from '@general/colors';
import { useScreenSmDown, useScreenMinMd } from '@hooks/useResponsive';

const getIconDesktop = isActive => {
    const fill = isActive ? colors.primary : '#D3D0D5';
    const stroke = isActive ? '#fff' : '#000';
    return (
        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="19.6923" cy="19.7499" r="19.6923" fill={fill} />
            <path
                d="M19.2 20.2004C16.9408 20.2004 14.9368 20.6865 13.62 21.1094C12.648 21.4225 12 22.2949 12 23.2724V26.2957H18.4"
                stroke={stroke}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M19.2002 20.2005V20.2005C16.9914 20.2005 15.2002 17.7327 15.2002 15.629V14.8671C15.2002 12.7635 16.9914 11.0576 19.2002 11.0576V11.0576C21.409 11.0576 23.2002 12.7635 23.2002 14.8671V15.629C23.2002 17.7327 21.409 20.2005 19.2002 20.2005Z"
                stroke={stroke}
                strokeLinecap="square"
            />
            <path d="M22.4004 25.5338L24.0004 27.0576L28.0004 23.248" stroke={stroke} strokeLinecap="square" />
        </svg>
    );
};

const getIconMobile = isActive => {
    const stroke = isActive ? '#246EFF' : '#1A1A1A';
    return (
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M8.2 10.1429C5.9408 10.1429 3.9368 10.6289 2.62 11.0518C1.648 11.3649 1 12.2373 1 13.2149V16.2381H7.4"
                stroke={stroke}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8.20001 10.1429V10.1429C5.99121 10.1429 4.20001 7.67505 4.20001 5.57143V4.80952C4.20001 2.7059 5.99121 1 8.20001 1V1C10.4088 1 12.2 2.7059 12.2 4.80952V5.57143C12.2 7.67505 10.4088 10.1429 8.20001 10.1429Z"
                stroke={stroke}
                strokeLinecap="square"
            />
            <path d="M11.4 15.4762L13 17L17 13.1905" stroke={stroke} strokeLinecap="square" />
        </svg>
    );
};

const MenuConnections = ({ isActive = false }) => {
    const isScreenSmDown = useScreenSmDown();
    const isScreenMinMd = useScreenMinMd();

    return (
        <>
            {isScreenSmDown && getIconMobile(isActive)}
            {isScreenMinMd && getIconDesktop(isActive)}
        </>
    );
};

MenuConnections.propTypes = {
    isActive: PropTypes.bool,
};

export default MenuConnections;
